import { Injectable, EventEmitter, inject } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private _deviceDetector = inject(DeviceDetectorService);

  mediaChangeEvent = new EventEmitter<string>();
  deviceInfo: any;

  initDeviceInfo() {
    this.deviceInfo = this._deviceDetector.getDeviceInfo();
  }

  showDeviceDebugInfo() {
    const isMobile = this._deviceDetector.isMobile();
    const isTablet = this._deviceDetector.isTablet();
    const isDesktopDevice = this._deviceDetector.isDesktop();
    const browser = this._deviceDetector.browser;
    console.log(JSON.stringify(this.deviceInfo));
    console.log(browser);
    console.log('isMobile: ' + isMobile); // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    console.log('isTablet: ' + isTablet); // returns if the device us a tablet (iPad etc)
    console.log('isDesktop:' + isDesktopDevice);
  }

  isBrowserCacheEnabled() {
    //return ('Chrome' === this._deviceDetector.browser || 'MS-Edge-Chromium' === this._deviceDetector.browser);
    return true;
  }

  isIE() {
    return 'IE' === this._deviceDetector.browser();
  }

  isMobile() {
    return this._deviceDetector.isMobile();
  }

  isTablet() {
    return this._deviceDetector.isTablet();
  }
}
